module.exports = {"320322001":"沛城街道","320322002":"大屯街道","320322003":"汉源街道","320322004":"汉兴街道","320322101":"龙固镇","320322102":"杨屯镇","320322105":"胡寨镇","320322106":"魏庙镇","320322107":"五段镇","320322108":"张庄镇","320322109":"张寨镇","320322110":"敬安镇","320322111":"河口镇","320322112":"栖山镇","320322113":"鹿楼镇","320322114":"朱寨镇","320322115":"安国镇","320322403":"沛县湖西农场管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320322.json
// module id = 952
// module chunks = 0